import React, { useState, useEffect } from "react";
import { filter, find, map } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  LanguageOption,
  ApiUrl,
  WebUrl,
  SessionKey,
  Language,
  ApiKey,
} from "./../../util/Constant.js";
import { setBusy, setIdle } from "../../redux/AppAction.js";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import ApiEngine from "./../../util/ApiEngine.js";
import { createMultiPartFormBody, stringIsNullOrEmpty } from "./../../util/Util.js";
import { saveLanguageId } from "../../redux/LanguageAction.js";
import moment from "moment";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const CnyFooter = "/img/footer/CNY_Footer.png";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const _dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const gameCategories = useSelector((state) => {
    return filter(state.gameState.gameCategories, (item) => {
      return item.id > 0;
    });
  });
  const [cnyEndTime, setCnyEndTime] = useState(moment("2023-02-05 23:59:59:999").format("YYYY-MM-DD HH:mm:ss:SSS"));
  const [currentTime, setCurrentTime] = useState(moment().format("YYYY-MM-DD HH:mm:ss:SSS"));

  const selectedLanguageId = useSelector(
    (state) => state.languageState.languageId
  );

  const isLoggedIn = useSelector((state) => state.authState.isLoggedIn);
  const _userData = useSelector((state) => state.authState.userData);
  const [providerList, setProviderList] = useState([]);

  useEffect(() => {
    if (selectedLanguageId) {
      const selectedItem = find(
        LanguageOption,
        (item) => item.code === selectedLanguageId
      );

      setSelectedLanguage(selectedItem.prefix);
    }
    getProviderList();
  }, [selectedLanguageId]);

  const aboutMenu = [
    {
      link: WebUrl._URL_ABOUT_US,
      text: t("ABOUT_US"),
    },
    {
      link: WebUrl._URL_HELP_CENTRE,
      text: t("HELP_CENTRE"),
    },
    {
      link: WebUrl._URL_TERMS_AND_CONDITIONS,
      text: t("TERMS_AND_CONDITIONS"),
    },
    {
      link: WebUrl._URL_PRIVACY_POLICY,
      text: t("PRIVACY_POLICY"),
    },
    {
      link: WebUrl._URL_AFFILIATE_PARTNER_PROGRAM,
      text: t("AFFILIATE_PARTNER_PROGRAM"),
    },
    {
      link: WebUrl._URL_RESPONSIBLE_GAMBLING,
      text: t("RESPONSIBLE_GAMBLING"),
    },
  ];

  const supportMenu = [
    /* TEMPORARILY HIDE PAYMENT OPTIONS UNTIL WE HAVE CONTENT */
    // {
    //   link: WebUrl._URL_HELP_CENTRE_CATEGORY.replace(":category", "Payment"),
    //   text: t("PAYMENT_OPTION"),
    // },
    {
      link: WebUrl._URL_HELP_CENTRE,
      text: t("HELP_CENTRE"),
    },
    {
      link: WebUrl._URL_HELP_CENTRE_SUB_CATEGORY
        .replace(":category", "Game")
        .replace(":sub_category", "How to Guide"),
      text: t("HOW_TO_GUIDE"),
    },
    {
      link: WebUrl._URL_HELP_CENTRE_SUB_CATEGORY
        .replace(":category", "Game")
        .replace(":sub_category", "General Betting Rules"),
      text: t("GENERAL_BETTING_RULES"),
    },
  ];

  const paymentMethods = [
    {
      className: "img-payment",
      alt: "BankTransfer",
      image: "/img/footer/LocalBankTransfer.png",
    },
    {
      className: "img-payment",
      alt: "EWallet",
      image: "/img/footer/Ewallet.png",
    },
    {
      className: "img-payment",
      alt: "Pulsa",
      image: "/img/footer/Pulsa.png",
    }
  ];

  const security = [
    {
      alt: "Iovation",
      image: "/img/footer/security1.svg",
    },
    {
      alt: "ThreatMetrix",
      image: "/img/footer/security2.svg",
    },
  ];
  const browser = [
    {
      alt: "Crome",
      image: "/img/footer/browser1.svg",
    },
    {
      alt: "Firefox",
      image: "/img/footer/browser2.svg",
    },
  ];

  const socialMedias = [
    {
      alt: "facebook",
      image: "/img/social-media/fb.svg",
      link: "https://www.facebook.com/i8liveid.official/",
    },
    {
      alt: "youtube",
      image: "/img/social-media/yt.svg",
      link: "https://www.youtube.com/channel/UCxrKFaJx8jENt4hjrnKtYiQ",
    },
    //{
    //  alt: "twitter",
    //  image: "/img/social-media/tw.png",
    //  link: "https://twitter.com/?lang=en",
    //},
    {
      alt: "instagram",
      image: "/img/social-media/ig.svg",
      link: "https://instagram.com/i8.live",
    },
  ];

  const _LANG_NAME = {
    EN: "English",
    中文: "Chinese",
    BM: "Bahasa Melayu",
    BD: "Bangladesh",
    TH: "Thai",
    VI: "Vietnamese",
    ID: "Indonesia",
  };

  const onChangeLanguage = async (selectedLanguage) => {
    _dispatch(setBusy());
    setSelectedLanguage(
      LanguageOption.find((x) => x.code === selectedLanguage).prefix
    );
    i18n.changeLanguage(selectedLanguage);
    if (!isLoggedIn) {
      _dispatch(saveLanguageId(selectedLanguage, true));
    } else {
      _dispatch(saveLanguageId(selectedLanguage));
      let data = {};
      data["id"] = _userData.userId;
      data["selectedTheme"] = _userData.selectedTheme;
      data["languageSetting"] = selectedLanguage;
      data["isMemberOperate"] = true;

      // Silently update user's language settings
      await ApiEngine.post(
        ApiUrl._API_CREATE_OR_UPDATE_MEMBER,
        createMultiPartFormBody(data)
      );

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: "language",
            language: selectedLanguage,
          })
        );
      }
    }
    _dispatch(setIdle());
  };

  useEffect(() => {
    // const value = LanguageOption.find((item) => localStorage.getItem(SessionKey._LANGUAGE) === item.code );
    if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined') {
      if (LanguageOption.find(
        (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)) != undefined) {
        setSelectedLanguage(
          LanguageOption.find(
            (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)
          ).prefix
        );
      }
      else {
        setSelectedLanguage("ID");
        localStorage.setItem(SessionKey._LANGUAGE, "id");
      }
    } else {
      setSelectedLanguage("ID");
      localStorage.setItem(SessionKey._LANGUAGE, "id");
    }
  }, []);

  const getProviderList = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_AVAILABLE_MASTER_PRODUCT_DESKTOP);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      setProviderList(data);
    }
  }

  return (
    <>
      <footer id='footer'>
        <div className='container'>
          <div className="row">
            <div className="col-12">
              <div className="footer-link-container">
                <ul className='list-unstyled f-links'>
                  {aboutMenu &&
                    aboutMenu.length &&
                    map(aboutMenu, (item, index) => {
                      return (
                        <li key={index}>
                          <a href={item.link}>{item.text}</a>
                        </li>
                      );
                    })
                  }
                </ul>
                <div className="font-12">
                  <div className="copyright-text">
                    {t("COPYRIGHT", { year: moment().year(), version: process.env.REACT_APP_VERSION })}
                  </div>
                </div>
              </div>
              <hr className="footer-hr mt-4 mb-4" />
              <div className="footer-details-container">
                <h4>{t("FOOTER_DETAILS_HEADER_1")}</h4>
                <div>
                  {t("FOOTER_DETAILS_CONTENT_1_1")}
                </div>
                <br />
                <div>
                  {t("FOOTER_DETAILS_CONTENT_1_2")}
                </div>
                <br />
                <div>
                  {t("FOOTER_DETAILS_CONTENT_1_3")}
                </div>
                <h4 className="mt-4">{t("FOOTER_DETAILS_HEADER_2")}</h4>
                <div>
                  {t("FOOTER_DETAILS_CONTENT_2_1")}
                </div>
                <br />
                <div>
                  {t("FOOTER_DETAILS_CONTENT_2_2")}
                </div>
                <h4 className="mt-4">{t("FOOTER_DETAILS_HEADER_3")}</h4>
                <div>
                  {t("FOOTER_DETAILS_CONTENT_3")}
                </div>
                <h4 className="mt-4">{t("FOOTER_DETAILS_HEADER_4")}</h4>
                <div>
                  {t("FOOTER_DETAILS_CONTENT_4")}
                </div>
                <hr className="footer-hr mt-4 mb-4" />
              </div>
            </div>
          </div>

          <div className="row footer-4-col">
            <div className="col-md-3">
              <div className="footer-p-title">
                INFORMASI
              </div>
              <hr className="footer-hr mt-4 mb-4" />
              <div className="footer-details-container">
                <p className="mb-0 pb-2">
                  Registrasi
                </p>
                <p className="mb-4">
                  Bergabunglah i8 live untuk mengalami permainan yang luar biasa dan menarik. Nikmati kepuasan dengan bonus dan promosi di situs kami.
                </p>
                <p className="mb-0 pb-2">
                  Afiliasi
                </p>
                <p className="mb-4">
                  Menjadi mitra kami dengan bergabung dengan afiliasi i8 live. Dapatkan penghasilan dan komisi Anda setiap bulan dengan mengundang teman-teman Anda untuk bermain di i8 live.
                </p>
                <p className="mb-0 pb-2">
                  Game yang bertanggung jawab
                </p>
                <p className="mb-4">
                  i8 live menawarkan game online terbaik dengan tanggung jawab penuh dan game fairplay. Keamanan selalu menjadi prioritas kami.
                </p>
                <p className="mb-0 pb-2">
                  Keamanan
                </p>
                <p className="mb-0">
                  i8 live memberikan game online terbaik dengan tanggung jawab penuh dan game fairplay. Keamanan selalu menjadi prioritas kami.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-p-title">
                PRODUK
              </div>
              <hr className="footer-hr mt-4 mb-4" />
              <div className="footer-details-container">
                <p className="mb-0 pb-2">
                  Sportsbook & Permainan Langsung
                </p>
                <p className="mb-4">
                  Dapatkan ribuan peluang olahraga setiap hari di i8 live. Kemungkinan untuk olahraga paling populer seperti sepak bola, bola basket, tenis, hoki tersedia dengan Taruhan Langsung setiap hari.
                </p>
                <p className="mb-0 pb-2">
                  Kasino online
                </p>
                <p className="mb-4">
                  i8 live menyediakan permainan kasino online terbaik seperti Baccarat, Blackjack, Roulete, Sic Bo, Poker, dan permainan populer lainnya di kasino online.
                </p>
                <p className="mb-0 pb-2">
                  Live Kasino
                </p>
                <p className="mb-0">
                  Main di live casino i8 live dan Anda akan merasakan sensasi kasino yang sebenarnya. Pilih berbagai permainan kasino yang Anda inginkan.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-p-title">
                PUSAT INFO
              </div>
              <hr className="footer-hr mt-4 mb-4" />
              <div className="footer-details-container">
                <p className="mb-0 pb-2">
                  Promosi
                </p>
                <p className="mb-4">
                  Dapatkan banyak promosi dari i8 live seperti bonus sambutan, bonus setoran, dan diskon tunai. Merasa puas dengan bergabung dalam promosi i8 live.
                </p>
                <p className="mb-0 pb-2">
                  Bantuan
                </p>
                <p className="mb-4">
                  Jika Anda memiliki masalah saat bermain Permainan online di i8 live, Anda dapat segera menghubungi kami, dan kami selalu siap membantu Anda 24 jam.
                </p>
                <p className="mb-0 pb-2">
                  Metode Transaksi
                </p>
                <p className="mb-4">
                  i8 live menyediakan bank lokal dan internasional untuk memudahkan setiap pelanggan untuk melakukan deposit dan penarikan. Metode transaksi dijamin aman, cepat, dan andal.
                </p>
                <p className="mb-0 pb-2">
                  Hubungi kami
                </p>
                <p className="mb-0">
                  Anda dapat menghubungi i8 live kapan saja jika Anda memiliki pertanyaan dan masalah. Anda dapat menghubungi kami melalui livechat, telepon, Skype, atau email. Staf kami selalu siap 24 jam untuk Anda.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-p-title">
                INFO BETTING
              </div>
              <hr className="footer-hr mt-4 mb-4" />
              <div className="footer-details-container">
                <p className="mb-0 pb-2">
                  Hasil Pertandingan Olahraga
                </p>
                <p className="mb-4">
                  Hasil lengkap dari Permainan olahraga Anda tersedia di i8 live. Dapatkan hasil terbaru yang Anda mainkan dalam riwayat Anda.
                </p>
                <p className="mb-0 pb-2">
                  Statistik Permainan
                </p>
                <p className="mb-4">
                  Akses semua detail Permainan olahraga yang Anda mainkan dan periksa riwayat Permainan secara penuh di i8 live.
                </p>
                <p className="mb-0 pb-2">
                  Permainan olahraga
                </p>
                <p className="mb-4">
                  Permainan pada permainan olahraga, dapatkan rintangan lengkap setiap hari dan rasakan kesenangan dengan sportsbook i8 live.
                </p>
                <p className="mb-0 pb-2">
                  Permainan Kasino
                </p>
                <p className="mb-0">
                  Rasakan kemewahan Permainan kasino, selesaikan riwayat Permainan lengkap yang telah Anda mainkan. Per Permainan kasino di i8 live, cepat, aman, dan menyenangkan.
                </p>
              </div>
            </div>
          </div>

          <div className='row footer-first-row'>
            <div className="col-12">
              <hr className="footer-hr" />
            </div>
            <div className='col-5'>
              <h1>{t("GAMING_LICENCE")}</h1>
              <LazyLoadImage
                src="/img/tobique.png"
                className='img-responsive tobique-license'
                alt='tobique'
                width="70"
                height="70"
                onClick={() => window.open('https://validate.thetgc.cc/validate?domain=i8.live&seal_id=8e9d1a697107b70174e39da9231482b219ff2477b6eb856ebaad8afcf455426cdf934d7002f6bb79e2ab9b6dd7539291&stamp=7449b197bceca498a81729ab38e64465')}
              />
              <p className="footer-gld mt-3">{t("GAMING_LICENCE_DETAILS")}</p>
            </div>
            <div className='col-4'>
              <h1>{t("CERTIFICATION")}</h1>
              <LazyLoadImage
                src="/img/footer/certificate.svg"
                className='img-responsive'
                alt='certificate'
                width="260"
                height="80"
              />
            </div>
            <div className='col-3'>
              <h1>{t("SECURITY")}</h1>
              <ul className='list-unstyled footer-payment'>
                {security &&
                  security.length &&
                  map(security, (item, index) => {
                    return (
                      <li key={index}>
                        <LazyLoadImage
                          src={item.image}
                          className='img-responsive'
                          alt={item.alt}
                          width="120"
                          height="30"
                        />
                      </li>
                    );
                  })
                }
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <hr className="footer-hr" />
            </div>
          </div>
          <div className='row footer-second-row'>
            <div className='col-5'>
              <h1>{t("PAYMENT_METHOD")}</h1>
              <ul className='list-unstyled payment-method'>
                {paymentMethods &&
                  paymentMethods.length &&
                  map(paymentMethods, (item, index) => {
                    return (
                      <li key={index}>
                        <LazyLoadImage
                          src={item.image}
                          className={item.className}
                          width="120"
                          height="60"
                          alt={item.alt}
                        />
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className='col-4 footer-social-media'>
              <h1>{t("FOLLOW_US")}</h1>
              <ul className='list-unstyled'>
                {socialMedias &&
                  socialMedias.length &&
                  map(socialMedias, (item, index) => {
                    return (
                      <li key={index} className="cursor-pointer">
                        <a onClick={() => window.open(item.link)}>
                          <LazyLoadImage
                            src={item.image}
                            className='img-responsive'
                            alt={item.alt}
                            width="30"
                            height="30"
                          />
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className='col-3'>
              <h1>{t("SUGGESTED_BROWSER")}</h1>
              <ul className='list-unstyled footer-payment'>
                {browser &&
                  browser.length &&
                  map(browser, (item, index) => {
                    return (
                      <li key={index}>
                        <LazyLoadImage
                          src={item.image}
                          className='img-responsive'
                          alt={item.alt}
                          width="30"
                          height="30"
                        />
                      </li>
                    );
                  })
                }
              </ul>
              <div className="footer-version">{"v." + process.env.REACT_APP_VERSION}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <hr className="footer-hr" />
              <h1>{t("GAME_PROVIDER") }</h1>
              <div className="footer-game-provider">
                {providerList.filter((x) => !stringIsNullOrEmpty(x["category"])).map((provider, index) => {
                  return (
                    <div key={index} style={{ width: '120px' }}>
                        <img
                          src={`/img/ug/header/game-category-white-icon/${provider.name}.png`}
                          className="w-100"
                          alt={provider.name}
                        />
                      </div>
                  )
                })}
              </div>
            </div>
          </div>
          {/* <div className='row copy-right'>
            <div className='col' style={{ display: "flex", justifyContent: "space-between" }}>
              <h1 className='font-14'>
                {t("COPYRIGHT")} 
                <LazyLoadImage
                  src="/img/footer/18plus.svg"
                  className='img-responsive'
                  alt="18+"
                  width="17"
                  height="17"
                />
              </h1>
              <div className="version-number">Ver. {process.env.REACT_APP_VERSION}</div>
            </div>
          </div> */}
        </div>
      </footer>
    </>
  );
};

export default Footer;
